module.exports = __webpack_public_path__ + "static/media/Email_Free_book.72f6760d.png";